import type { ConditionEvaluator } from "../types/conditionEvaluators.ts";
import type { BooleanCondition } from "../types/conditions/index.ts";
import { Operator } from "../types/operators.ts";
import { createThrowConditionNotImplementedForEvaluator, getSingleValue } from "./common.ts";

const throwNotImplemented = createThrowConditionNotImplementedForEvaluator("boolean");

export const conditionEvaluator: ConditionEvaluator<BooleanCondition> = (condition, resolve) => {
  const left = getSingleValue("boolean", condition.subject, resolve);
  const right = getSingleValue("boolean", condition.object, resolve);

  switch (condition.operator) {
    case Operator.EQ:
      return left === right;

    case Operator.NE:
      return left !== right;

    default:
      return throwNotImplemented(condition);
  }
};

export default conditionEvaluator;
